<template>
  <el-row @click.native="hidedialog">
    <el-col :span="24" style="overflow: hidden">
      <header
        class="comm-header"
        style="
          position: relative;
          display: flex;
          justify-content: space-between;
        "
      >
        <img class="header-img" src="../assets/companyLogo.png" alt />
        <!-- <i class="el-icon-question hover-i" style="float:right;font-size:22px;margin:29px 24px"></i> -->
        <!-- <div  class="el-icon-questio">
          <div class="el-icon-questio-box" style="padding:20px 20px 20px 20px">
          <i class="el-icon-phone-outline" style="padding-right:10px"></i>
          <span class="phone-outline">18971608045</span>
          </div>
        </div> -->
        <div class="tel">
          <i
            class="el-icon-phone-outline"
            style="margin-right: 5px; font-size: 20px"
          ></i
          >18971608045
        </div>
      </header>
      <div class="bg-container">
        <div></div>
      </div>
    </el-col>
    <el-col
      :xs="{ span: 22, offset: 1 }"
      :sm="{ span: 18, offset: 3 }"
      :md="{ span: 16, offset: 4 }"
      :lg="{ span: 8, offset: 8 }"
    >
      <div class="reg-container">
        <h4>
          <span>注册账号</span>
        </h4>
        <!-- 企业名称由2到30个的汉字、字母、（）、()、&、.组成 -->
        <el-form
          class="about-form"
          :model="form"
          ref="validateForm"
          label-width="100px;"
          label-position="center"
        >
          <el-form-item
            prop="orgName"
            :rules="[
              { required: true, message: '请输入企业名称', trigger: 'change' },
              {
                pattern: /^[\u4E00-\u9FA5\(\)（）\_\.\a-zA-Z&]{2,30}$/gi,
                message: '企业名称由2-30位汉字、字母、小括号、下划线、点组成',
                trigger: 'change',
              },
            ]"
          >
            <label for="orgName"
              ><span style="color: red">*</span>企业名称</label
            >
            <el-input
              placeholder="企业名称"
              v-model="form.orgName"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <!--          <el-form-item-->
          <!--            prop="abbreviation"-->
          <!--            :rules="[-->
          <!--              { required: true, message: '请输入企业简称', trigger: 'change' },-->
          <!--              {-->
          <!--                pattern: /^[\u4e00-\u9fa5a-zA-Z\.\\(\\)\\（\\）]{2,10}$/,-->
          <!--                message: '企业简称为2到10个的汉字或英文',-->
          <!--                trigger: 'change',-->
          <!--              },-->
          <!--            ]"-->
          <!--          >-->
          <!--            <label for="abbreviation"-->
          <!--              ><span style="color:red">*</span>企业简称</label-->
          <!--            >-->
          <!--            <el-input-->
          <!--              placeholder="企业简称"-->
          <!--              v-model="form.abbreviation"-->
          <!--              autocomplete="off"-->
          <!--            ></el-input>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item-->
          <!--            prop="contact"-->
          <!--            :rules="[-->
          <!--              {-->
          <!--                required: true,-->
          <!--                message: '请输入企业联系人',-->
          <!--                trigger: 'change',-->
          <!--              },-->
          <!--              {-->
          <!--                pattern: /^[\u4e00-\u9fa5a-zA-Z\.]{2,5}$/,-->
          <!--                message: '企业联系人为2到5个的汉字或英文',-->
          <!--                trigger: 'change',-->
          <!--              },-->
          <!--            ]"-->
          <!--          >-->
          <!--            <label for="contact"-->
          <!--              ><span style="color:red">*</span>企业联系人</label-->
          <!--            >-->
          <!--            <el-input-->
          <!--              placeholder="联系人"-->
          <!--              v-model="form.contact"-->
          <!--              autocomplete="off"-->
          <!--            ></el-input>-->
          <!--          </el-form-item>-->

          <el-form-item
            prop="mobile"
            :rules="[
              { required: true, message: '请输入手机号码', trigger: 'change' },
              {
                pattern: /^1\d{10}$/,
                message: '请输入正确的手机号码',
                trigger: 'change',
              },
            ]"
          >
            <label for="mobile"
              ><span style="color: red">*</span>手机号码</label
            >
            <el-input
              placeholder="企业联系手机"
              v-model="form.mobile"
              autocomplete="off"
            ></el-input>
          </el-form-item>

          <el-form-item
            prop="code"
            style="text-align: center"
            :rules="[
              {
                required: true,
                message: '请输入手机验证码',
                trigger: 'change',
              },
              {
                pattern: /^\d{6}$/,
                message: '请输入正确的手机验证码',
                trigger: 'change',
              },
            ]"
          >
            <div class="code-container">
              <label><span style="color: red">*</span>验证码</label>
              <div>
                <el-input
                  placeholder="手机验证码"
                  v-model="form.code"
                  autocomplete="off"
                ></el-input>
                <span>
                  <el-button
                    style="float: right; width: 95%"
                    :disabled="comeFromMail"
                    :loading="getCodeLoad"
                    @click="getModifyCode(form.mobile)"
                    >{{
                      getCodeLoad ? btnTime + "s后获取" : "获取验证码"
                    }}</el-button
                  >
                </span>
              </div>
            </div>
          </el-form-item>
          <!-- <el-form-item prop="username" :rules="[
              { required: true, message: '请输入用户名', trigger: 'change' },
              {
                pattern: /^[a-zA-Z0-9_-]{6,16}$/,
                message: '用户名为6到16位（字母，数字）',
                trigger: 'change',
              },
            ]">
            <label for="username"><span style="color: red">*</span>登录账号</label>
            <el-input placeholder="登录账号" v-model="form.username" autocomplete="off"></el-input>
          </el-form-item> -->
          <el-form-item
            prop="password"
            :rules="[
              { required: true, message: '请输入登录密码', trigger: 'change' },
              {
                pattern: /^[\w_!@#$%&?._-]{6,16}$/,
                message: '密码为6-16位（字母，数字，!@#$%&?._- ）',
                trigger: 'change',
              },
            ]"
          >
            <label for="loginPwd"
              ><span style="color: red">*</span>登录密码</label
            >
            <el-input
              type="text"
              name="password"
              class="password"
              placeholder="密码"
              v-model="form.password"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <!--          <el-form-item>-->
          <!--            <label>营业执照</label>-->
          <!--            <div class="upload-container">-->
          <!--              <span>上传营业执照</span>-->
          <!--              <el-upload-->
          <!--                ref="upload1"-->
          <!--                :action="`${$http.defaults.img_url}`"-->
          <!--                list-type="picture-card"-->
          <!--                :on-preview="handlePictureCardPreview"-->
          <!--                :before-upload="handleBefore1"-->
          <!--                :on-success="handleSuccess1"-->
          <!--                :on-error="handleError"-->
          <!--                :before-remove="handleBeforeRemove"-->
          <!--                :on-remove="handleRemove1"-->
          <!--                accept="image/gif,image/jpeg,image/jpg,image/png"-->
          <!--              >-->
          <!--                <i class="el-icon-plus"></i>-->
          <!--              </el-upload>-->
          <!--            </div>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item>-->
          <!--            <label>公司logo</label>-->
          <!--            <div class="upload-container">-->
          <!--              <span>上传公司logo</span>-->
          <!--              <el-upload-->
          <!--                ref="upload"-->
          <!--                :action="`${$http.defaults.img_url}`"-->
          <!--                list-type="picture-card"-->
          <!--                :on-preview="handlePictureCardPreview"-->
          <!--                :before-upload="handleBefore"-->
          <!--                :on-success="handleSuccess"-->
          <!--                :on-error="handleError"-->
          <!--                :before-remove="handleBeforeRemove"-->
          <!--                :on-remove="handleRemove"-->
          <!--                accept="image/gif,image/jpeg,image/jpg,image/png"-->
          <!--              >-->
          <!--                <i class="el-icon-plus"></i>-->
          <!--              </el-upload>-->
          <!--            </div>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item>-->
          <!--            <label><span style="color:red"></span>邀请码</label>-->
          <!--            &lt;!&ndash; <label >邀请码</label> &ndash;&gt;-->
          <!--            <el-input-->
          <!--              placeholder="请输入6位数的邀请码"-->
          <!--              v-model="form.invitedCode"-->

          <!--              autocomplete="off"-->
          <!--              :disabled="flag"-->
          <!--              style="padding-left:120px"-->
          <!--            ></el-input>-->
          <!--         -->
          <!--          </el-form-item>-->
        </el-form>
        <p>
          <!-- <img @click="handleImg(checked)" style="vertical-align: middle" :src="[checked ? png1 : png2]" alt="" /> -->
          <!-- <i :class="[checked?'el-icon-success':'el-icon-error']"></i> -->
          <el-checkbox v-model="checked"> </el-checkbox>
          <span style="font-size: 14px; margin-left: 5px">我已阅读并同意</span>
          <span
            @click="OnCheck"
            style="font-size: 14px; cursor: pointer; color: #4e6ef2"
            >《用户注册协议》</span
          >
        </p>
        <div class="dialog-footer">
          <el-button
            class="login-btn"
            :loading="loading"
            type="primary"
            @click="handleReg"
            >创 建 账 号</el-button
          >
        </div>
        <div style="padding: 25px 0; text-align: center">
          <p>
            已有账号？<span
              @click="goLogin"
              style="color: #3bc492; cursor: pointer"
              >马上登录</span
            >
          </p>
        </div>
      </div>
    </el-col>
    <!-- 用户协议 -->
    <el-dialog :visible.sync="checkVisible" :close-on-click-modal="false">
      <div class="reg-text" v-html="content"></div>
      <div style="text-align: center; margin-top: 20px">
        <el-button
          @click="onArgeen('ok')"
          class="login-btn"
          style="width: 350px"
          type="primary"
          >同 意</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="ImgdialogVisible" :close-on-click-modal="false">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>

    <!-- <el-dialog :visible.sync="endVisible">
      <div class="end-container">
          <i class="el-icon-success"></i>
          <p>您的账号已创建，系统将会在24小时内进行审核，审核结果将以短信的形式通知到您的手机，请耐心等待。</p>

          <el-button style="width:100px;color:#fff" class="login-btn" @click="handleToLogin">确定</el-button>
      </div>
    </el-dialog> -->
    <tip></tip>
  </el-row>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { constants } from "crypto";
import { fail } from "assert";
// import png1 from '../assets/checked.png'
// import png2 from '../assets/nocheck.png'
import { openRegister, getcatloglist } from "@/api/authController.js";
import { helpCenterPage, helpDetailById } from "@/api/setUp.js";
import tip from "@/components/tip.vue";

import { Console } from "console";
export default {
  name: "About",
  components: {
    tip,
  },

  data() {
    return {
      inputtype: "",
      // png1,
      // png2,
      endVisible: false,
      loading: false,
      imgSrc: "",
      dialogImageUrl: "",
      ImgdialogVisible: false,
      checkVisible: false,
      checked: true,
      dialogVisible: false,
      dialogImageUrl: "",
      activeName: "first",
      fileList1: 0,
      fileList2: [],
      form: {
        app: "SALARY",
        username: "",
        password: "",
        mobile: "",
        code: "",
        fullName: "",
        province: "",
        city: "",
        district: "",
        org: "",
        orgName: "",
        userName: "",
        contact: "",
        abbreviation: "",
      },
      getCodeLoad: false,
      btnTime: 60,
      comeFromMail: false,
      logoImg: "",
      lincenseImg: "",
      flag: false,
      catloginfo: {
        app: "SALARY",
        pageNumber: 0,
        size: 100,
        title: "",
      },
      pageinfo: {
        pageNumber: 0,
        size: 1000,
        catalogId: "",
        title: "悦享工资条用户注册协议",
      },
      content: "",
    };
  },
  methods: {
    hidedialog(e) {
      console.log(e.target.className);
      if (e.target.className != "tipList") {
        this.$store.state.showTip = false;
      }
    },
    async getcatlog() {
      let { data } = await getcatloglist(this.catloginfo);
      let res = data.filter((item) => {
        return item.mask == "XIEYI";
      });
      this.pageinfo.catalogId = res[0].id;
      let { data: res1 } = await helpCenterPage(this.pageinfo);
      let { data: res2 } = await helpDetailById({ id: res1[0].id });
      this.content = res2.content;
    },
    goLogin() {
      // this.$router.go(-1)
      this.$router.push("/login");
    },
    handleImg(val) {
      this.checked = val ? false : true;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.ImgdialogVisible = true;
    },
    handleToLogin() {
      this.$router.push("/login");
    },
    handleReg() {
      this.$refs["validateForm"].validate(async (valid) => {
        if (valid) {
          if (this.checked) {
            // if (this.lincenseImg && this.logoImg) {
            this.loading = true;
            // this.$http
            //   .post('customer/add', {
            //     invitedCode: this.form.invitedCode,
            //     abbreviation: this.form.abbreviation,
            //     code: this.form.code,
            //     contact: this.form.contact,
            //     orgName: this.form.orgName,
            //     licenseUrl: this.lincenseImg,
            //     password: this.form.password,
            //     logoUrl: this.logoImg,
            //     mobile: this.form.mobile,
            //     username: this.form.username,
            //   })
            //   .then((res) => {
            //     console.log(res.data)
            //     this.$notify({
            //       title: '成功',
            //       message: '注册成功',
            //       type: 'success',
            //     })
            //     this.loading = false
            //     // this.endVisible=true
            //     this.$router.push('/login')
            //   })
            //   .catch((e) => {
            //     this.loading = false
            //   })
            // username: this.form.username,
            const { data } = await openRegister({
              app: this.form.app,
              invitedCode: this.form.invitedCode,
              abbreviation: this.form.orgName,
              code: this.form.code,
              contact: this.form.contact,
              orgName: this.form.orgName,
              licenseUrl: this.lincenseImg,
              password: this.form.password,
              logoUrl: this.logoImg,
              mobile: this.form.mobile,
              username: this.form.username,
              action: "register",
            }).finally(() => {});
            if (data.code == 200) {
              this.$notify({
                title: "成功",
                message: "注册成功",
                type: "success",
              });
              // this.loading = false
              // // this.endVisible=true
              // this.$router.push('/login')
              window.sessionStorage.setItem("token", data.data + "");
              this.$router.push("/index");
              this.loading = false;
            } else {
              this.$notify({
                title: "失败",
                message: data.msg || "注册失败",
                type: "warning",
              });
              this.loading = false;
            }

            // } else {
            //   this.$message({
            //     message: "请上传logo和营业执照",
            //     type: "warning"
            //   });
            // }
          } else {
            this.$message({
              message: "请先同意用户守则",
              type: "warning",
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onArgeen(val) {
      if (val == "ok") {
        this.checkVisible = false;
        this.checked = true;
      } else {
        this.checkVisible = false;
        this.checked = false;
      }
    },
    OnCheck() {
      this.checkVisible = true;
      // this.arggen?this.checked=true:this.checked=false
    },
    handleRemove(file, fileList) {
      this.$refs.upload.$children[0].$el.style.display = "none";
      this.$refs.upload.$children[1].$el.style.display = "flex";
      this.logoImg = "";
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleError() {
      this.$notify({
        title: "失败",
        message: "图片上传失败，请稍后重试",
        type: "error",
      });
    },
    handleSuccess(response, file, fileList) {
      console.log(file);
      if (response.ok) {
        this.fileList1 = fileList.length;
        this.logoImg = response.data[0];
      } else {
        this.$notify({
          title: "失败",
          message: `${response.message},请删除后重新上传`,
          type: "warning",
        });
      }
      // this.logoImg = response.data[0];
    },
    handleBefore() {
      this.$refs.upload.$children[1].$el.style.display = "none";
      this.$refs.upload.$children[0].$el.style.display = "inline-block";
    },
    //
    handleRemove1(file, fileList) {
      this.$refs.upload1.$children[0].$el.style.display = "none";
      this.$refs.upload1.$children[1].$el.style.display = "flex";
      this.lincenseImg = "";
    },
    handleSuccess1(response, file, fileList) {
      console.log(response);
      if (response.ok) {
        this.fileList1 = fileList.length;
        this.lincenseImg = response.data[0];
      } else {
        this.$notify({
          title: "失败",
          message: `${response.message},请删除后重新上传`,
          type: "warning",
        });
      }
    },
    handleBefore1() {
      this.$refs.upload1.$children[1].$el.style.display = "none";
      this.$refs.upload1.$children[0].$el.style.display = "inline-block";
    },
    handleBeforeRemove() {},
    getModifyCode(test) {
      let phoneReg = new RegExp(/^1\d{10}$/);
      if (phoneReg.test(test)) {
        this.btnTime = 60;
        this.getCodeLoad = true;
        var timer = setInterval(() => {
          this.btnTime--;
          if (this.btnTime <= 0) {
            this.getCodeLoad = false;
            clearInterval(timer);
          }
        }, 1000);
        this.$http
          .post(`/authority-center/open/register/sms_code?mobile=${test}`)
          .then(
            (res) => {
              if (res.data.code == 200) {
                this.$notify({
                  title: "成功",
                  message: "验证码已发送至手机，请注意查收",
                  type: "success",
                });
              } else {
                this.$notify({
                  title: "警告",
                  message: res.data.msg || "网络异常",
                  type: "warning",
                });
              }
            },
            (error) => {
              this.btnTime = 0;
            }
          );
      } else {
        this.$message({
          message: "请填写正确的手机号码",
          type: "warning",
        });
      }
    },
  },
  mounted() {
    this.getcatlog();
    // debugger;
    this.form.invitedCode = this.$route.fullPath.slice(7, 13);
    if (this.form.invitedCode) {
      this.flag = true;
    }
    if (this.$route.query.phone) {
      this.form.mobile = this.$route.query.phone;
    }
    setTimeout(() => {
      this.inputtype = "password";
      console.log(this.inputtype);
    }, 2000);
  },
};
</script>

<style lang="less" scoped>
.header-img {
  margin: 15px 40px;
  width: 200px;
  height: 60px;
  // style="margin: 15px 40px; width: 200px; height: 60px"
}
/deep/.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-height: 76vh;
}

/deep/.el-dialog .el-dialog__body {
  flex: 1;
}
.tel {
  color: #3bc492;
  font-size: 16px;
  margin-right: 40px;
}
.el-icon-questio {
  float: right;
  font-size: 22px;
  margin: 15px 24px;
  margin-top: 30px;
  // background-color: #000;
  width: 174px;
  height: 50px;
  font-size: 16px;
  color: #333;
}
.bg-container {
  position: absolute;
  width: 100%;
  height: 600px;
  background: url("../assets/block1.png") no-repeat;
  background-size: 30%;
  z-index: -1;
  > div {
    position: absolute;
    left: 65%;
    width: 200px;
    top: 400px;
    height: 200px;
    background: url("../assets/img02.png") no-repeat;
    background-size: 100%;
  }
}

.end-container {
  text-align: center;
  i {
    font-size: 140px;
    color: #3bc492;
  }
  p {
    margin: 40px;
  }
}

.hover-i {
  float: right;
  color: rgba(131, 143, 153, 1);
  font-size: 16px;
  cursor: pointer;
  position: relative;
  &:hover {
    &:after {
      position: absolute;
      bottom: -30px;
      right: 0px;
      width: 300px;
      height: 30px;
      line-height: 30px;
      border-radius: 10px;
      font-size: 12px;
      color: rgba(44, 45, 58, 1);
      text-align: center;
      background: rgba(243, 245, 247, 1);
      border-radius: 4px;
      content: "如有疑问，请致电客服热线：075-323421";
    }
  }
}

.code-container {
  display: flex;
  label {
    width: 20%;
    text-align: left;
  }
  > div {
    flex: 1;
    display: flex;
    .el-input {
      flex: 3;
    }
    span {
      flex: 2;
    }
  }
}

.login-btn {
  width: 100%;
  margin-top: 13px;
  background: rgba(59, 196, 146, 1);
  border-radius: 28px;
  border-color: rgba(59, 196, 146, 1);
  &:hover {
    background: rgba(59, 196, 146, 0.7);
    border-color: rgba(59, 196, 146, 0.7);
  }
}

.upload-container {
  display: flex;
  height: 144px;
  padding-left: 10%;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  padding: 16px;
  span {
    flex: 3;
  }
}

.reg-container {
  h4 {
    font-size: 22px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: rgba(59, 196, 146, 1);
    line-height: 30px;
    text-align: center;
    margin-bottom: 32px;
    span {
      height: 50px;
      display: inline-block;
      border-bottom: 2px solid rgba(59, 196, 146, 1);
    }
  }
  padding: 37px 50px;
  box-shadow: 0px 4px 16px 0px rgba(131, 143, 153, 0.15);
  border-radius: 16px;
  margin: 40px 0;
}

@media (min-width: 300px) and (max-width: 768px) {
  .header-img {
    width: 180px;
    margin-left: 10px;
    margin-top: 9px;
  }
  .tel {
    margin-right: 10px;
  }
  .bg-container > div {
    left: 43%;
  }
  .reg-container {
    padding: 5px;
  }
}
/deep/.el-form-item__error {
  margin-left: 20%;
}
@font-face {
  font-family: text-security-disc;
  src: url("https://raw.githubusercontent.com/noppa/text-security/master/dist/text-security-disc.woff");
}
.password {
  -webkit-text-security: disc;
  font-family: text-security-disc;
}
.reg-text {
  height: 60vh;
  overflow: auto;
}
</style>
